
<template>
<!-- 选择所有设备 -->
    <div>
       <el-form
        :model="selectForm"
        ref="ruleForm"
        label-width="80px"
          
      >
         <el-row :gutter="24">
             <el-col span="6">
                <el-form-item label="设备编号" prop="checkPass">
                        <el-input clearable v-model="selectForm.code" placeholder="设备编号" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
            <el-col span="6">
                <el-form-item label="设备名称" prop="checkPass">
                    <el-input clearable v-model="selectForm.name" placeholder="设备名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
             <el-col span='6' >
                 <el-form-item label="设备类型" prop="objectType">
                    <el-select
                    clearable
                    ref="typeIdSelect"
                    @clear="objectTypeClear"
                    :value="selectForm.typeName"
                    v-model="selectForm.typeName"
                    placeholder="设备类型"
                    style="width: 100%;"
                    >
                        <!-- :load="typeLazyLoadTree"
                        lazy -->
                    <el-option :value="selectForm.typeId" show-all-levels :label="selectForm.typeName">
                        <el-tree
                        node-key="id"
                        :data="treeFormData"
                        :props="treeProps"
                        @node-click="typeNodeTreeClick"
                        >
                        </el-tree>
                    </el-option>
                    </el-select>
                </el-form-item>
             </el-col>
            <el-col span="6">

            </el-col>
            <el-col span="6"  style="margin-top:-2px">
                <el-form-item label="所属部门" prop="deptId">
                    <el-select          
                        :value="selectForm.deptName"
                        placeholder="所属部门"
                        style="width: 100%;"
                        clearable
                        @clear="deptClear"
                        @focus="showDetpTree=true"
                        >
                        <el-option v-show="showDetpTree" :value="selectForm.deptName" show-all-levels :label="selectForm.deptName">
                            <el-tree
                            node-key="id"
                            :data="treeFormDeptData"
                            :props="treeDeptProps"
                                @node-click="handleDeptNodeClick"
                            >
                            </el-tree>
                        </el-option>
                        </el-select>
                    </el-form-item>
            </el-col>
            <el-col span="6">
                <el-form-item label="存放位置" prop="areaId">
           
                    <el-select
                    clearable
                    @clear="areaClear"
                    :value="selectForm.areaName"
                    placeholder="存放区域"
                    style="width: 100%;"
                >
                    <el-option :value="selectForm.areaName" show-all-levels :label="selectForm.areaName">
                    <el-tree
                        node-key="id"
                        :data="treeFormAreaData"
                        :props="areaTreeProps"
                        :load="areaLazyLoadTree"
                        lazy
                        @node-click="areaNodeTreeClick"
                    >
                    </el-tree>
                    </el-option>
                </el-select>
                </el-form-item>
            </el-col>
            <el-col span="12">
                <el-form-item label="采购价格">
                    <div style="display:flex;">
                        <el-input  clearable  placeholder="采购价格"  v-model="selectForm.purchaseStartPrice "  maxlength="12"
                        />-
                            <el-input clearable placeholder="采购价格" v-model="selectForm.purchaseEndPrice " maxlength="12" />
                    </div>
                </el-form-item>
            </el-col>
            <el-col span="6">
                <div style="float:right">
                              <el-button type="primary" @click="search" icon="el-icon-search" size="small"> 
                                搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete"  size="small" style="margin-right:24pxg"> 
                                清空 </el-button>
                </div>
            </el-col>
          
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="deviceList"
            :page.sync="page"
            ref="crud"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="search"
            @refresh-change="search">
             
            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" > {{' '}}</el-radio>
            </template>
            <template slot="purchasePrice" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.purchasePrice)  }}</span></div>
            </template>
        </avue-crud>
        <div class="btnArea" style="text-align:right;">
            <el-button size="small" type="primary" icon="el-icon-circle-plus-outline"  @click="submitData">提交</el-button>
            <el-button size="small" icon="el-icon-circle-close" style="margin-right:24px"  @click="cancelOperate">取消</el-button>
         </div>
       </el-row>
        </el-form>
    </div>
</template>

<script>
import { getDeviceList } from '@/api/crmedical/device/deviceInventory';
import { tree } from '@/api/crmedical/device/devicetype';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';
import { getDictionary } from '@/api/common';
import { lazyTree } from '@/api/crmedical/project/area';
import {
  getProjectDept,
  treeByProjectDeptId,
  childNode,
  userList,
} from '@/api/crmedical/device/device';
export default {
  props: ['projectId'],
  data() {
    return {
      radio: '',
      showDetpTree: false,
      selectForm: {
       
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
        purchaseStartPrice: '',
        purchaseEndPrice: '',
      },
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'title',
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属部门
      treeFormData: [], //设备类型
      deviceList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      option: {
        page: true,
        height:'260',
        calcHeight:'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
            align:"center"
          },
          {
            label: '设备类型',
            prop: 'typeName',
          },
          {
            label: '设备名称',
            prop: 'name',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备品牌',
            prop: 'brand',
          },
          {
            label: '所属部门',
            prop: 'deptName',
          },
          {
            label: '存放位置',
            prop: 'areaName',
          },
          {
            label: '启用时间',
            prop: 'startUseTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
           {
            label: '采购价格',
            prop: 'purchasePrice',
            slot:true,
            align:"right"
          },
          {
            label: '资产状态',
            prop: 'assetStatus',
            dataType:"string",
            dicUrl:"/api/blade-system/dict/dictionary?code=device_asset_status",
            props:{
              label:"dictValue",
              value:"dictKey",
            }
            
          },
          {
            label: '设备型号',
            prop: 'model',
            hide:true
          },
          {
            label: '报废日期',
            prop: 'scrapTime',
            format: 'yyyy-MM-dd',
            type: 'date',
            hide:true
          },
          {
            label: '责任人',
            prop: 'chargeManName',
            hide:true
          },
        ],
      },
    };
  },
  created() {
    console.log('1111', this.projectId);
    this.initData();
  },
  methods: {
    sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
    cancelOperate(){
      this.$emit("cancelOperate")
    },
      areaClear(){
      this.selectForm.areaName=""
      this.selectForm.areaId=""
    },
    deptClear(){
      this.selectForm.deptName=""
      this.selectForm.deptId=""
    },
    objectTypeClear(){
      this.selectForm.typeId=""
      this.selectForm.typeName=""
    },
    searchClear(){
     this.selectForm={
        projectId: '',
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
        purchaseStartPrice:'',
        purchaseEndPrice:''
      }
      this.selectForm.projectId = this.projectId
    },
    submitData() {
      if( this.radio.id){
        
        this.$emit('choiceData', this.radio);
      }else{
        this.$message({
          message: '请选择设备',
          type: 'warning'
        });
      }
      
      
      
    },
    search() {
      this.radio = '';
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      console.log(this.selectForm);
      if (
        (this.selectForm.purchaseStartPrice == '' && this.selectForm.purchaseEndPrice == '') ||
        (reg.test(this.selectForm.purchaseStartPrice) && reg.test(this.selectForm.purchaseEndPrice))
      ) {
        if (this.selectForm.purchaseStartPrice > this.selectForm.purchaseEndPrice) {
          //大金额在后面
          let transfromNum = this.selectForm.purchaseEndPrice;
          this.selectForm.purchaseEndPrice = this.selectForm.purchaseStartPrice;
          this.selectForm.purchaseStartPrice = transfromNum;
        }
      } else {
        let sum =
          Number(this.selectForm.purchaseStartPrice) + Number(this.selectForm.purchaseEndPrice);
        if (sum == this.selectForm.purchaseStartPrice || sum == this.selectForm.purchaseEndPrice) {
          this.$message.error(' 一个金额范围');
          this.loading = false;
          return;
        } else {
          this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
          this.loading = false;
          return;
        }
      }
      this.loading = false;
      getDeviceList(
        Object.assign(
          { projectId: this.projectId, current: this.page.currentPage, size: this.page.pageSize },
          this.selectForm
        )
      )
        .then(({ data }) => {
          this.deviceList = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initData() {
      getDictionary('device_object_type').then(({ data }) => {
        this.objectType = data;
      });
      //   this.queryAreaSelect(this.projectId);
      this.treeByProjectDeptId(this.projectId);
        this.queryDeviceSelect(this.projectId);
    },
    getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },
    //选中的设备提交
    choiceSubmit() {
      this.$emit('choiceData', this.radio);
    },

    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.treeFormAreaData = data;
      });
    },
    queryDeviceSelect(value) {
      tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
        console.log('设备', data);
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormData = data;
        console.log('设备下拉款', this.treeFormData);
      });
    },
    typeNodeTreeClick(node) {
      console.log(node);
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm = Object.assign({},this.selectForm,{
        typeName:nodeTitle,
        typeId:nodeId
      });
        this.$refs.typeIdSelect.blur();
          this.$forceUpdate();
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      console.log(node)
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.areaName = nodeTitle;
      this.selectForm.areaId = nodeId;
        this.$refs.typeIdSelect.blur();
          this.$forceUpdate();
    },
    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
      });
    },
    handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    typeLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      console.log(node);
      tree({ id: id, projectId: this.projectId, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        } else {
          data = [];
        }

        resolve(data);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
